import React, { useEffect, useRef } from 'react';

interface AdUnitProps {
  slot: string;
  format?: 'auto' | 'rectangle' | 'horizontal' | 'vertical';
  className?: string;
}

export default function AdUnit({ slot, format = 'auto', className = '' }: AdUnitProps) {
  const adRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    try {
      const adsbygoogle = (window as any).adsbygoogle;
      if (adsbygoogle && adRef.current) {
        adsbygoogle.push({});
      }
    } catch (error) {
      console.warn('AdSense error:', error);
    }
  }, []);

  // Optimized ad sizes for different formats with reduced minimum heights
  const formatStyles = {
    auto: {
      minHeight: '50px',
      margin: '0 auto',
      maxWidth: '100%'
    },
    rectangle: {
      minHeight: '250px',
      width: '300px',
      margin: '0 auto',
      maxWidth: '100%'
    },
    horizontal: {
      minHeight: '50px',
      width: '728px',
      margin: '0 auto',
      maxWidth: '100%'
    },
    vertical: {
      minHeight: '600px',
      width: '160px',
      margin: '0 auto'
    }
  };

  return (
    <div 
      className={`ad-container ${className}`}
      style={{
        ...formatStyles[format],
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="PUBLISHER-ID"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
        data-ad-layout-key="-fg+5n+6t-e7+r"
      />
    </div>
  );
}